<div class="kUploadMonitorSection">
  <div class="kUploadMonitorSectionHeading">
    <span class="kUploadMonitorSectionHeadingTitle">{{ title }}</span>

    <a class="kUploadMonitorSectionHeadingDetails" (click)="_openDetails()">
      {{ 'applications.upload.uploadMonitor.viewDetails' | translate }}
    </a>
  </div>
  <div class="kUploadMonitorSectionContent">
    <ng-container [ngSwitch]="layout">
      <div *ngSwitchCase="'totals'">
        <span *ngIf="!_isUpToDate">
          <span class="kUploadMonitorStatus" *ngIf="uploading !== 0">
            <i class="kIconrefresh_small kUploadMonitorStatusIcon uploading"></i>
            {{ _uploadingTitle | translate: { '0': uploading } }}
          </span>
          <span class="kUploadMonitorStatus" *ngIf="queued !== 0">
            <i class="kIconupload2 kUploadMonitorStatusIcon queued"></i>
            {{ 'applications.upload.uploadMonitor.queued' | translate: { '0': queued } }}
          </span>
          <span class="kUploadMonitorStatus" *ngIf="completed !== 0">
            <i class="kIconcheck_small kUploadMonitorStatusIcon completed"></i>
            {{ 'applications.upload.uploadMonitor.completed' | translate: { '0': completed } }}
          </span>
          <span class="kUploadMonitorStatus" *ngIf="errors !== 0">
            <i class="kIconerror kUploadMonitorStatusIcon error"></i>
            {{ 'applications.upload.uploadMonitor.error' | translate: { '0': errors } }}
          </span>
        </span>
        <span *ngIf="_isUpToDate">
          <span class="kUploadMonitorStatus">
            <i class="kIconcheck_small kUploadMonitorStatusIcon completed"></i>
            {{ 'applications.upload.uploadMonitor.upToDate' | translate }}
          </span>
        </span>
      </div>

      <span *ngSwitchCase="'loading'">
        {{ 'applications.upload.uploadMonitor.loading' | translate }}
      </span>
      <span *ngSwitchCase="'error'">
        {{ 'applications.upload.uploadMonitor.errors.poll' | translate }}
      </span>
      <span *ngSwitchCase="'recoverableError'">
        {{ 'applications.upload.uploadMonitor.errors.prepare' | translate }}
        <a (click)="requestToRecover.emit()">{{ 'app.common.retry' | translate }}</a>
      </span>
    </ng-container>
  </div>
</div>
